import {put} from "@redux-saga/core/effects";
import * as actions from "./blackListActions";
import * as systemActions from "../system/systemActions";
import axios from "axios";

export function* blackListLoadSaga(action) {
    let config = {
        headers: {
            Authorization: "Bearer " + action.token,
            Accept: "application/json"
        }
    };

    try {
        const response = yield axios.get(
            "/v1/blacklist",
            config
        );
        
        yield put(actions.blackListLoaded(response.data.result));

    } catch (error) {

    }
}

export function* addBlackList(action) {

    let config = {
        headers: {
            Authorization: "Bearer " + action.token,
            Accept: "application/json"
        }
    }

    let response = null;

    try {
        response = yield axios.post(
            "/v1/blacklist/" + action.payload.action,
            action.payload,
            config
        );

        if (response.data.result && response.data.result.success) {
            yield put(actions.blackListLoad(action.token));
            yield put(systemActions.systemNotification(response.data.result.message));
        } else {
            yield put(systemActions.axiosError(response.data.result));
        }

    } catch (error) {
        console.log("Error:", error)
    }
}

